module.exports = {
    cobrandingPartners: [
        'further',
        'carefirst',
        'capblue',
        'horizon',
        'kansascity',
        'mhc',
        'vermont',
        'louisiana',
    ]
}
